<template>
	<v-layout child-flex>
		<v-card class="deliveries">
			<v-toolbar color="grey lighten-4" class="header elevation-0">

				<v-toolbar-title>
					Front routes
				</v-toolbar-title>

			</v-toolbar>
			<v-data-table
				fluid
				:headers="headers"
				:items="$router.options.routes"
				:search="search"
			/>
		</v-card>
	</v-layout>
</template>

<script>
export default {
	computed: {
		headers () {
			return [
				{ text: 'Name', value: 'name' },
				{ text: 'Description', value: 'description' },
				{ text: 'Route', value: 'path' }
			];
		}
	}
};
</script>
